import request from '@/utils/request';

// 农担公司详情
export function getGuaranteeDetail() {
  return request({
    url: 'insurance/info/cooperation/guarantee/110001',
    method: 'GET',
  });
}
